import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRatingStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 15.0745L14.8499 17.8368C15.738 18.343 16.8249 17.5947 16.5911 16.6482L15.3056 11.4537L19.5945 7.95405C20.3775 7.31575 19.9568 6.10517 18.9284 6.02813L13.2839 5.57692L11.0751 0.66857C10.6778 -0.222857 9.32219 -0.222857 8.92485 0.66857L6.71612 5.56591L1.07159 6.01713C0.0431899 6.09416 -0.37752 7.30474 0.405468 7.94305L4.69438 11.4427L3.40887 16.6372C3.17514 17.5837 4.26198 18.332 5.15015 17.8258L10 15.0745Z",
		fill: "white"
	})
});
export default SvgRatingStar;
